import { AppstoreOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const MyDecksPage = lazyRouteComponent(() => import('./pages/list'));
const DeckDetailsPage = lazyRouteComponent(() => import('./pages/details'));
const DeckImportPage = lazyRouteComponent(() => import('./pages/import'));
const PublicDeckPage = lazyRouteComponent(() => import('./pages/public'));
const OptimizedPurchasePage = lazyRouteComponent(
  () => import('./pages/optimized-purchase'),
);

export const getRoutes = (): Route[] => [
  {
    page: OptimizedPurchasePage,
    path: ROUTE_PATHS.OPTIMIZED_PURCHASE,
    title: 'Compra otimizada',
    hidden: true,
  },
  {
    page: MyDecksPage,
    path: ROUTE_PATHS.MY_DECKS,
    title: 'Meus decks',
    icon: AppstoreOutlined,
  },
  {
    page: DeckDetailsPage,
    path: ROUTE_PATHS.DECK_DETAILS,
    title: 'Detalhes do deck',
    hidden: true,
  },
  {
    page: DeckImportPage,
    path: ROUTE_PATHS.DECK_IMPORT,
    title: 'Importar deck',
    hidden: true,
  },
];

export const getPublicRoutes = (): Route[] => [
  {
    page: PublicDeckPage,
    path: ROUTE_PATHS.PUBLIC_DECK,
    title: 'Deck compartilhado',
    hidden: true,
    public: true,
  },
];
